import React, { ReactNode } from 'react';

export const renderTemplate = (
  template: string,
  replacements: Record<string, ReactNode>
): ReactNode => {
  const parts = template.split(/(\{\{[A-Z_]+\}\})/);
  return parts.map((part, i) => {
    const match = part.match(/^\{\{([A-Z_]+)\}\}$/);
    const content = match && match[1] in replacements ? replacements[match[1]] : part;
    return content ? <React.Fragment key={i}>{content}</React.Fragment> : null;
  });
};
